import React from 'react';
import { syllabusData } from '../data/syllabus';
import { ExternalLink, CheckCircle } from 'lucide-react';

const SilabusPage = () => {
  return (
    <div className="py-16 bg-blue-50 min-h-screen transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-display font-bold text-center mb-6 text-blue-900">Silabus Lengkap</h1>
        <p className="text-center text-blue-700 mb-12 max-w-3xl mx-auto text-lg">
          Semua materi pembelajaran kami dirancang berdasarkan kurikulum terbaik dari Coursera,
          disesuaikan dengan kebutuhan industri data science dan AI di Indonesia.
        </p>

        <div className="space-y-6">
          {syllabusData.map((item) => (
            <div key={item.no} className="bg-white rounded-2xl border-2 border-blue-200 p-6 hover:shadow-xl hover:border-blue-400 transition">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-blue-700 rounded-full flex items-center justify-center shadow-md">
                    <span className="text-blue-50 font-bold text-lg">{item.no}</span>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-blue-900 mb-3">{item.title}</h3>

                  {item.source && (
                    <div className="mb-3">
                      <p className="text-sm font-semibold text-blue-800 mb-2">Sumber Materi:</p>
                      <a
                        href={item.source}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 hover:text-blue-900 text-sm hover:underline inline-flex items-center gap-2 bg-blue-100 px-3 py-1.5 rounded-lg mb-2"
                      >
                        <ExternalLink className="w-4 h-4" />
                        Coursera - Lihat Kursus
                      </a>
                      {item.source2 && (
                        <>
                          <br />
                          <a
                            href={item.source2}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-700 hover:text-blue-900 text-sm hover:underline inline-flex items-center gap-2 bg-blue-100 px-3 py-1.5 rounded-lg"
                          >
                            <ExternalLink className="w-4 h-4" />
                            Coursera - Lihat Kursus (2)
                          </a>
                        </>
                      )}
                    </div>
                  )}

                  {item.outcomes.length > 0 && (
                    <div>
                      <p className="text-sm font-semibold text-blue-800 mb-2">Keluaran Pembelajaran:</p>
                      <ul className="space-y-2">
                        {item.outcomes.map((outcome, idx) => (
                          <li key={idx} className="text-sm text-blue-700 flex items-start gap-2">
                            <CheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                            <span>{outcome}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SilabusPage;
